"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAnalyticsSegmentsIndexEnum = exports.UserAnalyticsEnum = exports.EventAnalyticsSegmentsIndexEnum = exports.EventAnalyticsEnum = exports.AnalyticsValueTypeEnum = exports.AnalyticsTypeEnum = exports.AnalyticsDurationEnum = exports.AnalyticsIntervalEnum = void 0;
var AnalyticsIntervalEnum;
(function (AnalyticsIntervalEnum) {
    AnalyticsIntervalEnum["Hour"] = "Hour";
    AnalyticsIntervalEnum["Day"] = "Day";
    AnalyticsIntervalEnum["Week"] = "Week";
    AnalyticsIntervalEnum["Month"] = "Month";
    AnalyticsIntervalEnum["Year"] = "Year";
})(AnalyticsIntervalEnum = exports.AnalyticsIntervalEnum || (exports.AnalyticsIntervalEnum = {}));
var AnalyticsDurationEnum;
(function (AnalyticsDurationEnum) {
    AnalyticsDurationEnum["AllTime"] = "All time";
    AnalyticsDurationEnum["Today"] = "Today";
    AnalyticsDurationEnum["OneWeek"] = "One week";
    AnalyticsDurationEnum["OneMonth"] = "One month";
    AnalyticsDurationEnum["MonthToDate"] = "Month to date";
    AnalyticsDurationEnum["YearToDate"] = "Year to date";
    AnalyticsDurationEnum["OneYear"] = "One year";
    AnalyticsDurationEnum["Custom"] = "Custom dates";
})(AnalyticsDurationEnum = exports.AnalyticsDurationEnum || (exports.AnalyticsDurationEnum = {}));
;
var AnalyticsTypeEnum;
(function (AnalyticsTypeEnum) {
    AnalyticsTypeEnum["Overview"] = "Overview";
    AnalyticsTypeEnum["TotalSales"] = "Total Sales";
    AnalyticsTypeEnum["TicketSales"] = "Ticket Sales";
    AnalyticsTypeEnum["TicketsSold"] = "Tickets Sold";
    AnalyticsTypeEnum["TicketComps"] = "Ticket Comps";
    AnalyticsTypeEnum["TicketsScanned"] = "Tickets Scanned";
    AnalyticsTypeEnum["UpgradesScanned"] = "Add-ons Scanned";
    AnalyticsTypeEnum["UpgradeSales"] = "Add-ons Sales";
    AnalyticsTypeEnum["UpgradesSold"] = "Add-ons Sold";
    AnalyticsTypeEnum["UpgradeComps"] = "Add-ons Comps";
    AnalyticsTypeEnum["Promotions"] = "Promotions";
    AnalyticsTypeEnum["ScannedCounts"] = "Scanned Counts";
    AnalyticsTypeEnum["ExtraFeeRevenue"] = "Extra Fee Revenue";
    AnalyticsTypeEnum["TotalOrders"] = "Total Orders";
    AnalyticsTypeEnum["AvgOrderValue"] = "Avg. Order Value";
    AnalyticsTypeEnum["OnlineSessions"] = "Online Sessions";
    AnalyticsTypeEnum["OnlineConversationRate"] = "Online Converstation Rate";
    AnalyticsTypeEnum["EventAnalytics"] = "Event Analytics";
    AnalyticsTypeEnum["UserAnalytics"] = "User Analytics";
})(AnalyticsTypeEnum = exports.AnalyticsTypeEnum || (exports.AnalyticsTypeEnum = {}));
var AnalyticsValueTypeEnum;
(function (AnalyticsValueTypeEnum) {
    AnalyticsValueTypeEnum["Quantity"] = "Quantity";
    AnalyticsValueTypeEnum["Currency"] = "Currency";
    AnalyticsValueTypeEnum["Percent"] = "Percent";
})(AnalyticsValueTypeEnum = exports.AnalyticsValueTypeEnum || (exports.AnalyticsValueTypeEnum = {}));
var EventAnalyticsEnum;
(function (EventAnalyticsEnum) {
    EventAnalyticsEnum["SoldOutPercentage"] = "Sold Out";
    EventAnalyticsEnum["TotalSales"] = "Total Sales";
})(EventAnalyticsEnum = exports.EventAnalyticsEnum || (exports.EventAnalyticsEnum = {}));
var EventAnalyticsSegmentsIndexEnum;
(function (EventAnalyticsSegmentsIndexEnum) {
    EventAnalyticsSegmentsIndexEnum[EventAnalyticsSegmentsIndexEnum["SoldOut"] = 0] = "SoldOut";
    EventAnalyticsSegmentsIndexEnum[EventAnalyticsSegmentsIndexEnum["TotalSales"] = 1] = "TotalSales";
})(EventAnalyticsSegmentsIndexEnum = exports.EventAnalyticsSegmentsIndexEnum || (exports.EventAnalyticsSegmentsIndexEnum = {}));
var UserAnalyticsEnum;
(function (UserAnalyticsEnum) {
    UserAnalyticsEnum["EventsAttendedCount"] = "EventAttendedCount";
    UserAnalyticsEnum["TicketsPurchasedCount"] = "TicketsPurchasedCount";
    UserAnalyticsEnum["LifeTimeValue"] = "LifeTimeValue";
})(UserAnalyticsEnum = exports.UserAnalyticsEnum || (exports.UserAnalyticsEnum = {}));
var UserAnalyticsSegmentsIndexEnum;
(function (UserAnalyticsSegmentsIndexEnum) {
    UserAnalyticsSegmentsIndexEnum[UserAnalyticsSegmentsIndexEnum["EventsAttendedCount"] = 0] = "EventsAttendedCount";
    UserAnalyticsSegmentsIndexEnum[UserAnalyticsSegmentsIndexEnum["TicketsPurchasedCount"] = 1] = "TicketsPurchasedCount";
    UserAnalyticsSegmentsIndexEnum[UserAnalyticsSegmentsIndexEnum["LifeTimeValue"] = 2] = "LifeTimeValue";
})(UserAnalyticsSegmentsIndexEnum = exports.UserAnalyticsSegmentsIndexEnum || (exports.UserAnalyticsSegmentsIndexEnum = {}));
// const EventAnalytics: IAnalytics = {
//   label: AnalyticsTypeEnum.EventAnalytics,
//   type: AnalyticsValueTypeEnum.General,
//   interval: AnalyticsIntervalEnum.Hour,
//   segments: [
//     {
//       label: EventAnalyticsEnum.SoldOutPercentage,
//       type: AnalyticsValueTypeEnum.Percent,
//       coordinates: [
//         {
//           x: 1,
//           y: 68,
//         },
//       ]
//     },
//     {
//       label: EventAnalyticsEnum.TotalSales,
//       type: AnalyticsValueTypeEnum.Currency,
//       coordinates: [
//         {
//           x: 1,
//           y: 2120100,
//         },
//       ]
//     }
//   ]
// }
// const TicketSalesCard: IAnalytics = {
//   label: AnalyticsTypeEnum.TicketSales,
//   type: AnalyticsValueTypeEnum.Currency,
//   interval: AnalyticsIntervalEnum.Hour,
//   totalValue: 1000,
//   coordinates: [
//     {
//       x: 1,
//       y: 1,
//     }
//   ],
//   segments: [
//     {
//       label: 'General Admission',
//       type: AnalyticsValueTypeEnum.Currency,
//       totalValue: 300,
//       coordinates: [
//         {
//           x: 1,
//           y: 1,
//         },
//         {
//           x: 2,
//           y: 1,
//         }
//       ]
//     }
//   ]
// }
//# sourceMappingURL=IAnalytics.js.map